import {Component, OnInit, ViewChild, HostListener} from '@angular/core';
import {GlobalDataService} from '../../housekeeping/services/global-data.service';
import {CaseAdvanceSearch} from '../../housekeeping/models/data-model';
import {Router, ActivatedRoute} from '@angular/router';
import {Angular2Csv} from 'angular2-csv/Angular2-csv';
import {CaseService} from '../services/case.service';
import * as moment from 'moment';
declare var $: any;
import {DatePipe} from '@angular/common';
import {ExportAvailability} from '../../../config';
@Component({
    selector: 'app-case',
    templateUrl: '../views/case.component.html',
    styleUrls: ['../css/case.component.css'],
    providers: [DatePipe]
})
export class CaseComponent implements OnInit {
  public userTZ = '';
  public searchKey: any = "";
  public userId: any;
  public roleId: any;
  public offset = 0;
  public limit = 10;
  public statusList: any;
  public priorityList: any;
  public caseSourceList: any;
  public dealerList: any;
  public caseTypeList: any;
  public assignToList: any = [];
  public datePickerClick = false;
  public headerCasesList: any = [];
  public caseList: any = [];
  public noData: boolean = false;
  public showBack: boolean = false;
  public showNext: boolean = false;
  public caseExportStatus = true;
  public calledAdvanceSearchList: boolean = false;
  public advanceOffset: number = 0;
  public showAdvanceLink: boolean = true;
  public normalSearch: boolean = false;
  public basicOffset: number = 0;
  public advanceSearchList: boolean = false;
  public showAdvance: boolean = false;
  public showsubmission: boolean = false;
  public showsubmissionrange: boolean = false;
  public column: string = "";
  public sort: string = "ASC";
  public direction: boolean = false;
  public list: boolean = false;
  public normalSearchValues: any = {lastname: "", orderBy: "", sortBy: "", direction: false};
  public caseListValues: any = {orderBy: "", sortBy: "", direction: ""};
  public caseSearchObj = new CaseAdvanceSearch(this.userId, this.searchKey, [], [], [], [], [], "", "", "", "", [], "", this.offset, this.limit, true, this.sort, this.column,"",[],false);
  public EXPORT = ExportAvailability.export;
  public enablePagination: boolean = true;
  public finalExportData: any = [];
  public totalRecords = 0;
  public pageSize = 10;
  public p: number=parseInt(sessionStorage.getItem('casePageNo'));
  public pageExist: any;
   public RelativeDate = ["Last 7 Days","Last 30 Days","Last 60 Days"]
  //dropdown values
  public statusSelected: any = [];
  public prioritySelected: any = [];
  public caseTypeSelected: any = [];
  public dealerSelected: any = [];
  public regionSelected:any =[]
  public assignToSelected: any = [];
  public caseSourceSelected: any = [];
  public RDSelected:string =""

  //Boolean
  public isStatusAll: boolean = false;
  public isPriorityAll: boolean = false;
  public isCaseTypeAll: boolean = false;
  public isDealerAll: boolean = false;
  public isRegionAll:boolean = false;
  public isAssignToAll: boolean = false;
  public isCaseSourceAll: boolean = false;

  //dropdown count
  public statusCount: number = 0;
  public priorityCount: number = 0;
  public caseTypeCount: number = 0;
  public dealerCount: number = 0;
  public regionCount:number = 0;
  public assignToCount: number = 0;
  public caseSourceCount: number = 0;

  //count max values
  public statusIndex: any = [];
  public priorityIndex: any = [];
  public caseTypeIndex: any = [];
  public dealerIndex: any = [];
  public regionIndex:any =[]
  public assignToIndex: any = [];
  public caseSourceIndex: any = [];

  //storing value to filter from criteria
  public filterStatus: any = [];
  public filterPriority: any = [];
  public filterCaseType: any = [];
  public filterDealer: any = [];
  public filterRegion:any =[];
  public filterAssignTo: any = [];
  public filterCaseSource: any = [];


  //For session storage
  public selectOrDeselect = {
    'isStatusAll': false,
    'isPriorityAll': false,
    'isCaseTypeAll': false,
    'isDealerAll': false,
    'isAssignToAll': false,
    'isCaseSourceAll': false,
    'isRegionAll':false
  };

  //dropdown settings
  public statusSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'code',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
   public RDSettings = {
    singleSelection: true,
    idField: 'id',
    textField: 'code',
    itemsShowLimit: 1,
    allowSearchFilter: false
  };
  public prioritySettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'code',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  public caseTypeSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'code',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  public dealerSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'name',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  public assignToSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'fullName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  public caseSourceSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'code',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };

    public regionSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'codeDescription',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  //array to push criteria values after adv search
  public showCriteria: any = [];
  public regionList:any =[];
  openDate: Date;
  fromDate: Date;
  toDate: Date;
  public showRadion:boolean = false
  public firatsNameRadioOption:boolean = false
  public showRadionForLastname:boolean = false
  public lastNameRadioOption:boolean = false
//    storeOpenDate: string
//    storeFromDate: string
//    storeToDate: string

  @ViewChild('openDateCal') openDateCal;
  @ViewChild('fromDateCal') datePicker1;
  @ViewChild('toDateCal') datePicker2;
  @ViewChild('searchForm') searchFormObj: any;


  constructor(private _caseService: CaseService, private _router: Router, public _dataService: GlobalDataService, private datePipe: DatePipe) {
  }

  ngOnInit() {
    if (sessionStorage.getItem("pageLimit") !== null) {
      this.limit = Number(sessionStorage.getItem("pageLimit"));
      this.pageSize = Number(sessionStorage.getItem("pageLimit"))

    }

    if (!this.EXPORT) {
      document.getElementById("casesExport").classList.add('hidden');
    }
    //$('[data-toggle="tooltip"]').tooltip("enable");
    //        this.userId = localStorage.getItem('userId');
    //        this.roleId = localStorage.getItem('roleId');
    this.userTZ = this._dataService.USER_TZ;
    this.userId = sessionStorage.getItem('userId');
    this.roleId = sessionStorage.getItem('roleId');
    this.prepareCaseTableData();
    const path = this._dataService.getPreviousUrl();
    if (!path.includes('/cases/detail')) {
      this.getCaseList();
    }
    if (path.includes('/cases/detail')) {
      if (sessionStorage.getItem("normalSearch") !== null) {
        this.basicOffset = Number(sessionStorage.getItem("normalSearch"));
        if (this.basicOffset > 0) {
          this.showBack = true;
        }
        this.normalSearchValues = JSON.parse(sessionStorage.getItem("normalSearchValues"));
        if (this.normalSearchValues != null) {
          this.searchKey = this.normalSearchValues.lastName;
          this.column = this.normalSearchValues.orderBy;
          this.sort = this.normalSearchValues.sortBy;
          this.direction = this.normalSearchValues.direction;
        }

        this.basicSearch();
      } else if (sessionStorage.getItem("advanceSearch") !== null) {
        this.direction = JSON.parse(sessionStorage.getItem("advanceSearchDirection"));
        this.advanceOffset = Number(sessionStorage.getItem("advanceSearch"));
        if (this.advanceOffset > 0) {
          this.showBack = true;
        }

        /**
         * @author Nagendra
         * @description To load data from session storage
         * @created date 24-10-2018
         * @modified date 24-10-2018
         */
        this.selectOrDeselect = JSON.parse(sessionStorage.getItem("selectOrDeselect"));
        //To prevent select all and to send empty array
        this.isStatusAll = this.selectOrDeselect.isStatusAll;
        this.isPriorityAll = this.selectOrDeselect.isPriorityAll;
        this.isCaseTypeAll = this.selectOrDeselect.isCaseTypeAll;
        this.isDealerAll = this.selectOrDeselect.isDealerAll;
        this.isAssignToAll = this.selectOrDeselect.isAssignToAll;
        this.isCaseSourceAll = this.selectOrDeselect.isCaseSourceAll;

        this.caseSearchObj = JSON.parse(sessionStorage.getItem("advancesearchfields"));
        this.searchKey = this.caseSearchObj.searchKey;
        this.statusSelected = this.caseSearchObj.statusIds;
        this.prioritySelected = this.caseSearchObj.priorityIds;
        this.caseTypeSelected = this.caseSearchObj.caseTypeIds;
        this.dealerSelected = this.caseSearchObj.dealerIds;
        this.regionSelected = this.caseSearchObj.regionIds;
        this.assignToSelected = this.caseSearchObj.assignTos;
        this.caseSourceSelected = this.caseSearchObj.caseSourceIds;


        if (this.caseSearchObj.caseOpenDate != null && this.caseSearchObj.caseOpenDate != "") {
          this.openDate = new Date(this.caseSearchObj.caseOpenDate);
          this.onSelectOpen(this.openDate)
        }
        if (this.caseSearchObj.fromDate != null && this.caseSearchObj.fromDate != "") {
        //  this.showsubmission = false;
        //  this.showsubmissionrange = true;
          this.fromDate = new Date(this.caseSearchObj.fromDate);
          this.onSelectFrom(this.fromDate)
        }
        if (this.caseSearchObj.toDate != null && this.caseSearchObj.toDate != "") {
        //  this.showsubmission = false;
        //  this.showsubmissionrange = true;
          this.toDate = new Date(this.caseSearchObj.toDate);
          this.onSelectTo(this.toDate)
        }

        this.sort = this.caseSearchObj.sortBy;
        this.column = this.caseSearchObj.orderBy;
        this.advanceSearch();
      } else if (sessionStorage.getItem("list") !== null) {
        this.offset = Number(sessionStorage.getItem("list"));
        if (this.offset > 0) {
          this.showBack = true;
        }
        this.caseListValues = JSON.parse(sessionStorage.getItem("caseListValues"));
        if (this.caseListValues != null) {
          this.sort = this.caseListValues.sortBy;
          this.column = this.caseListValues.orderBy;
          this.direction = this.caseListValues.direction;
        }

        this.getCaseList();
      } else {
        this.getCaseList();
      }
    }
    this.getStatusList();
    this.getPriorityList();
    this.getCaseSourceList();
    this.getDealerList();
    this.getCaseTypeList();
    this.getAssignToList();
    this.getRegionList()

  }

  /**
   * @author Nagendra
   * @description To get row and label fields data
   */
  prepareCaseTableData() {
    this.headerCasesList = [];
    this._caseService.getcasePreference(this.userId, (result) => {
      if (result.length != 0) {
        result.sort((a: any, b: any) => {
          if (a.sequence < b.sequence) {
            return -1;
          } else if (a.sequence > b.sequence) {
            return 1;
          } else {
            return 0;
          }
        });
        this.headerCasesList = result;
      }
      //If no preference set go to default preferences
      else {
        this.getDefaultPreferences();
      }
    })
  }

  /**
   * @author Nagendra
   * @description To get default row and label fields data
   */
  getDefaultPreferences() {
    this._caseService.getviewSettings(result => {
      if (result.length != 0) {
        result.sort((a: any, b: any) => {
          if (a.sequence < b.sequence) {
            return -1;
          } else if (a.sequence > b.sequence) {
            return 1;
          } else {
            return 0;
          }
        });
        result.forEach(setting => {
          if (setting.isDefult == true) {
            this.headerCasesList.push({setting});
          }
        })
      }
    });
  }

  /**
   * @author Nagendra
   * @description Preparing case List data
   */
  getCaseList() {
    this.caseList = [];
    this.list = true;
    this.normalSearch = false;
    this.advanceSearchList = false;
    this.calledAdvanceSearchList = false;
    this.basicOffset = 0;
    this.advanceOffset = 0;
    this._caseService.getCaseList(this.userId, this.offset, this.limit, this.column, this.sort, (result) => {
      this.caseList = result.beans;

      if (this.offset == 0) {
        sessionStorage.removeItem("totalCount");
        this.totalRecords = result.pageCount;
        sessionStorage.setItem("totalCount", result.pageCount);
      }

      if (this.caseList == '') {
        this.showNext = false;
        this.noData = true;
      } else if (this.caseList.length < 10) {
        this.showNext = false;
        this.noData = false;
      } else if (this.caseList.length == 10) {
        this.showNext = true;
        this.noData = false;
      } else if (this.caseList.length > 10) {
        this.showNext = true;
        this.noData = false;
      } else {
        this.showNext = false;
        this.showBack = false;
        this.noData = true;
      }

      if (sessionStorage.getItem('totalCount') != null) {
        this.totalRecords = Number(sessionStorage.getItem("totalCount"));
      }
    });
  }

  /**
   * @author  Anand
   * @uses    Apply basic search
   */
  basicSearch() {

    this.statusSelected = [];
    this.prioritySelected = [];
    this.caseTypeSelected = [];
    this.dealerSelected = [];
    this.regionSelected =[]
    this.assignToSelected = [];
    this.caseSourceSelected = [];
    this.caseSearchObj = new CaseAdvanceSearch(this.userId, this.searchKey, [], [], [], [], [], "", "", null, null, [], null, this.offset, this.limit, true, this.sort, this.column,"",[],false);
    this.showCriteria = [];
    this.caseList = [];
    this.list = false;
    this.normalSearch = true;
    this.advanceSearchList = false;
    this.offset = 0;
    this.advanceOffset = 0;
    //To enable/disable Export functionality
    this.caseExportStatus = false;
    if(!this.caseExportStatus){
      //$('[data-toggle="tooltip"]').tooltip("disable");
    }
    if (this.basicOffset == 0) {
      this.showBack = false;
    }
    if (this.searchKey != null || this.searchKey != "") {
      this.caseSearchObj.searchKey = this.searchKey.trim();
    } else {
      this.caseSearchObj.searchKey = this.searchKey
    }
    this._caseService.caseBasicSearch(this.userId, this.searchKey, this.basicOffset, this.limit, this.column, this.sort,this.firatsNameRadioOption, (result) => {
      this.caseList = result.beans;

      if (this.basicOffset == 0) {
        sessionStorage.removeItem("totalCount");
        this.totalRecords = result.pageCount;
        sessionStorage.setItem("totalCount", result.pageCount);
      }

      if (this.caseList == '') {
        this.showNext = false;
        this.noData = true;
      } else if (this.caseList.length < 10) {
        this.showNext = false;
        this.noData = false;
      } else if (this.caseList.length == 10) {
        this.showNext = true;
        this.noData = false;
      } else if (this.caseList.length > 10) {
        this.noData = false;
      } else {
        this.showNext = false;
        this.showBack = false;
        this.noData = true;
      }

      if (sessionStorage.getItem('totalCount') != null) {
        this.totalRecords = Number(sessionStorage.getItem("totalCount"));
      }
    });
  }

  /**
   * @author  Anand
   * @uses    Apply advance search
   */
  advanceSearch() {
    /**
     * @author Nagendra
     * @description Used to push values to showCriteria based on value given for advance fields
     * @uses To show criteria after advance search
     * @created Date 24-10-2018
     * @modified Date 26-10-2018
     */
     this.caseSearchObj.fromDate = this.datePipe.transform( this.caseSearchObj.fromDate , "yyyy-MM-dd");
     this.caseSearchObj.toDate =  this.datePipe.transform( this.caseSearchObj.toDate , "yyyy-MM-dd");
     this.caseSearchObj.caseOpenDate = this.datePipe.transform( this.caseSearchObj.caseOpenDate , "yyyy-MM-dd");
     this.showCriteria = [];
    //resetting count values
    this.statusCount = 0;
    this.priorityCount = 0;
    this.caseTypeCount = 0;
    this.dealerCount = 0;
    this.regionCount =0;
    this.assignToCount = 0;
    this.caseSourceCount = 0;

    //resetting filter values
    this.statusIndex = [];
    this.priorityIndex = [];
    this.caseTypeIndex = [];
    this.dealerIndex = [];
    this.regionIndex =[];
    this.assignToIndex = [];
    this.caseSourceIndex = [];

    //storing value to filter from criteria
    this.filterStatus = [];
    this.filterPriority = [];
    this.filterCaseType = [];
    this.filterDealer = [];
    this.filterRegion =[];
    this.filterAssignTo = [];
    this.filterCaseSource = [];
    //To enable/disable Export functionality
    this.caseExportStatus = false;
    this.showRadionForLastname = false
    this.showRadion = false
    if(!this.caseExportStatus){
     // $('[data-toggle="tooltip"]').tooltip("disable");
    }
    if (this.searchKey.trim() != "") {
      this.showCriteria.push({
        label: 'LastName',
        value: this.searchKey
      })
    }
     if (this.caseSearchObj.firstName.replace(/ /g, "") != "") {
      this.showCriteria.push({
        label: 'First Name',
        value: this.caseSearchObj.firstName
      })
    }
    if (this.caseSearchObj.caseNumber.replace(/ /g, "") != "") {
      this.showCriteria.push({
        label: 'Case Number',
        value: this.caseSearchObj.caseNumber
      })
    }
    if (this.caseSearchObj.vin.replace(/ /g, "") != "") {
      this.showCriteria.push({
        label: 'VIN',
        value: this.caseSearchObj.vin
      })
    }
    if (this.caseSearchObj.caseOpenDate != null && this.caseSearchObj.caseOpenDate != "") {
      this.showCriteria.push({
        label: 'Open Date',
        value: this.caseSearchObj.caseOpenDate
      })
    }
     if(this.RDSelected == "" || this.RDSelected == null){
    if (this.caseSearchObj.fromDate != null && this.caseSearchObj.fromDate != "") {
      this.showCriteria.push({
        label: 'From Date',
        value: this.caseSearchObj.fromDate
      })
    }
    if (this.caseSearchObj.toDate != null && this.caseSearchObj.toDate != "") {
      this.showCriteria.push({
        label: 'To Date',
        value: this.caseSearchObj.toDate
      })
    }
     }

    //To show All value for label if select all is used
    if (this.isStatusAll == true) {
      this.showCriteria.push({
        id: 'statusAll',
        label: 'Status',
        value: 'All'
      })
    }
    if (this.isPriorityAll == true) {
      this.showCriteria.push({
        id: 'priorityAll',
        label: 'Priority',
        value: 'All'
      })
    }
    if (this.isCaseTypeAll == true) {
      this.showCriteria.push({
        id: 'caseTypeAll',
        label: 'Case Type',
        value: 'All'
      })
    }
    if (this.isDealerAll == true) {
      this.showCriteria.push({
        id: 'dealerAll',
        label: 'Dealer Name',
        value: 'All'
      })
    }
     if (this.isRegionAll == true) {
      this.showCriteria.push({
        id: 'regionAll',
        label: 'Region',
        value: 'All'
      })
    }
    if (this.isAssignToAll == true) {
      this.showCriteria.push({
        id: 'assignToAll',
        label: 'Assigned To',
        value: 'All'
      })
    }
    if (this.isCaseSourceAll == true) {
      this.showCriteria.push({
        id: 'caseSourceNameAll',
        label: 'Case Source',
        value: 'All'
      })
    }




    this.caseSearchObj.statusIds = [];
    this.caseSearchObj.priorityIds = [];
    this.caseSearchObj.dealerIds = [];
    this.caseSearchObj.caseSourceIds = [];
    this.caseSearchObj.assignTos = [];
    this.caseSearchObj.caseTypeIds = [];
    this.caseSearchObj.regionIds = [];
    /**
     * @author Nagendra
     * @description dropdowns value are checked,if select all/unselect all used then boolean value for that will be true and it sends empty array
     */
    if (Object.keys(this.statusSelected).length > 0 && this.statusSelected != undefined && this.isStatusAll != true) {
      Object.keys(this.statusSelected).map(key => (
        this.caseSearchObj.statusIds.push(
          this.statusSelected[key]['id']),
          this.showCriteria.push({
            id: this.statusSelected[key]['id'],
            label: 'Status',
            value: this.statusSelected[key]['code']
          })
      ));
    }
    if (Object.keys(this.prioritySelected).length > 0 && this.prioritySelected != undefined && this.isPriorityAll != true) {
      Object.keys(this.prioritySelected).map(key => (
        this.caseSearchObj.priorityIds.push(
          this.prioritySelected[key]['id']),
          this.showCriteria.push({
            id: this.prioritySelected[key]['id'],
            label: 'Priority',
            value: this.prioritySelected[key]['code']
          })
      ));

    }
    if (Object.keys(this.caseTypeSelected).length > 0 && this.caseTypeSelected != undefined && this.isCaseTypeAll != true) {
      Object.keys(this.caseTypeSelected).map(key => (
        this.caseSearchObj.caseTypeIds.push(
          this.caseTypeSelected[key]['id']),
          this.showCriteria.push({
            id: this.caseTypeSelected[key]['id'],
            label: 'Case Type',
            value: this.caseTypeSelected[key]['code']
          })
      ));
    }
    if (Object.keys(this.dealerSelected).length > 0 && this.dealerSelected != undefined && this.isDealerAll != true) {
      Object.keys(this.dealerSelected).map(key => (
        this.caseSearchObj.dealerIds.push(
          this.dealerSelected[key]['id']),
          this.showCriteria.push({
            id: this.dealerSelected[key]['id'],
            label: 'Dealer Name',
            value: this.dealerSelected[key]['name']
          })
      ));
    }
      if (Object.keys(this.regionSelected).length > 0 && this.regionSelected != undefined && this.isRegionAll != true) {
          Object.keys(this.regionSelected).map(key => (
              this.caseSearchObj.regionIds.push(
              this.regionSelected[key]['id']),
          this.showCriteria.push({
           id: this.regionSelected[key]['id'],
            label: 'Region',
            value: this.regionSelected[key]['codeDescription']
          })
      ));
    }
    if (Object.keys(this.assignToSelected).length > 0 && this.assignToSelected != undefined && this.isAssignToAll != true) {
      Object.keys(this.assignToSelected).map(key => (
        this.caseSearchObj.assignTos.push(
          this.assignToSelected[key]['id']),
          this.showCriteria.push({
            id: this.assignToSelected[key]['id'],
            label: 'Assigned To',
            value: this.assignToSelected[key]['fullName']
          })
      ));
    }
    if (Object.keys(this.caseSourceSelected).length > 0 && this.caseSourceSelected != undefined && this.isCaseSourceAll != true) {
      Object.keys(this.caseSourceSelected).map(key => (
        this.caseSearchObj.caseSourceIds.push(
          this.caseSourceSelected[key]['id']),
          this.showCriteria.push({
            id: this.caseSourceSelected[key]['id'],
            label: 'Case Source',
            value: this.caseSourceSelected[key]['code']
          })
      ));
    }

       if (this.RDSelected != "" && this.RDSelected != null){
        this.caseSearchObj.toDate =""
        this.caseSearchObj.fromDate =""
        this.toDate = null
           this.fromDate = null
        this.showCriteria.push({
        label: 'Relative Open Date',
        value: this.RDSelected
      })
      }
     if (this.RDSelected != "" && this.RDSelected != undefined ) {
        var FromDate = new Date()
        var toDate = new Date()
      if(this.RDSelected == "Last 7 Days"){
       FromDate.setDate(FromDate.getDate() - 7);
      this.caseSearchObj.toDate =  this.datePipe.transform(toDate , "yyyy-MM-dd");
      this.caseSearchObj.fromDate =  this.datePipe.transform(FromDate , "yyyy-MM-dd");
      }
      if(this.RDSelected == "Last 30 Days"){
           FromDate.setDate(FromDate.getDate() - 30);
          this.caseSearchObj.toDate =  this.datePipe.transform(toDate , "yyyy-MM-dd");
          this.caseSearchObj.fromDate = this.datePipe.transform(FromDate , "yyyy-MM-dd");
      }if(this.RDSelected == "Last 60 Days"){
      FromDate.setDate(FromDate.getDate() - 60);
          this.caseSearchObj.toDate =  this.datePipe.transform(toDate , "yyyy-MM-dd");
          this.caseSearchObj.fromDate = this.datePipe.transform(FromDate , "yyyy-MM-dd");
      }
     }

    this.caseList = [];
    this.list = false;
    this.normalSearch = false;
    this.advanceSearchList = true;
    this.offset = 0;
    this.basicOffset = 0;
    if (this.advanceOffset == 0) {
      this.showBack = false;
    }
    this.showAdvanceLink = true;
    this.caseSearchObj.userId = this.userId;
    this.caseSearchObj.isPagination = this.enablePagination;
    if (this.searchKey != null || this.searchKey != "") {
      this.caseSearchObj.searchKey = this.searchKey.trim();
    } else {
      this.caseSearchObj.searchKey = this.searchKey;
    }
    this.caseSearchObj.offset = this.advanceOffset;
    this.caseSearchObj.orderBy = this.column;
    this.caseSearchObj.sortBy = this.sort;
    this.caseSearchObj.pageLimit = this.limit;
    this.noData = false;

    //counting dropdown values
    this.showCriteria.map((obj) => {
      if (obj.label == "Status") {
        this.statusCount++
      }
      if (obj.label == "Priority") {
        this.priorityCount++
      }
      if (obj.label == "Case Type") {
        this.caseTypeCount++
      }
      if (obj.label == "Dealer Name") {
        this.dealerCount++
      }
        if (obj.label == "Region") {
        this.regionCount++
      }
      if (obj.label == "Assigned To") {
        this.assignToCount++
      }
      if (obj.label == "Case Source") {
        this.caseSourceCount++
      }
    });

    //Checking index of particular label values and pushing

    if (this.statusCount > 3 && this.isStatusAll != true) {
      this.showCriteria.map((obj) => {
        if (obj.label == "Status") {
          this.statusIndex.push(this.showCriteria.indexOf(obj))
        }
      })
    }
    if (this.priorityCount > 3 && this.isPriorityAll != true) {
      this.showCriteria.map((obj) => {
        if (obj.label == "Priority") {
          this.priorityIndex.push(this.showCriteria.indexOf(obj))
        }
      })
    }
    if (this.caseTypeCount > 3 && this.isCaseTypeAll != true) {
      this.showCriteria.map((obj) => {
        if (obj.label == "Case Type") {
          this.caseTypeIndex.push(this.showCriteria.indexOf(obj))
        }
      })
    }
    if (this.dealerCount > 3 && this.isDealerAll != true) {
      this.showCriteria.map((obj) => {
        if (obj.label == "Dealer Name") {
          this.dealerIndex.push(this.showCriteria.indexOf(obj))
        }
      })
    }
//    if (this.dealerCount > 3 && this.isDealerAll != true) {
//      this.showCriteria.map((obj) => {
//        if (obj.label == "Dealer Name") {
//          this.dealerIndex.push(this.showCriteria.indexOf(obj))
//        }
//      })
//    }
      if (this.regionCount > 3 && this.isRegionAll!= true) {
      this.showCriteria.map((obj) => {
        if (obj.label == "Region") {
            this.regionIndex.push(this.showCriteria.indexOf(obj))
        }
      })
    }
    if (this.caseSourceCount > 3 && this.isCaseSourceAll != true) {
      this.showCriteria.map((obj) => {
        if (obj.label == "Case Source") {
          this.caseSourceIndex.push(this.showCriteria.indexOf(obj))
        }
      })
    }

    //Removing values from Criteria and appending one value with count
    if (Object.keys(this.statusIndex).length > 3 && this.isStatusAll != true) {
      this.statusIndex.map(index => {
        this.filterStatus.push(this.showCriteria[index])
      });
      this.showCriteria.push({
        id: 'maxStatus',
        label: 'Status',
        value: this.statusSelected[0].code + " + " + (this.statusCount - 1)
      })
    }

    if (Object.keys(this.priorityIndex).length > 3 && this.isPriorityAll != true) {
      this.priorityIndex.map(index => {
        this.filterPriority.push(this.showCriteria[index])
      });
      this.showCriteria.push({
        id: 'maxPriority',
        label: 'Priority',
        value: this.prioritySelected[0].code + " + " + (this.priorityCount - 1)
      })
    }

    if (Object.keys(this.caseTypeIndex).length > 3 && this.isCaseTypeAll != true) {
      this.caseTypeIndex.map(index => {
        this.filterCaseType.push(this.showCriteria[index])
      });
      this.showCriteria.push({
        id: 'maxCaseType',
        label: 'Case Type',
        value: this.caseTypeSelected[0].code + " + " + (this.caseTypeCount - 1)
      })
    }

    if (Object.keys(this.dealerIndex).length > 3 && this.isDealerAll != true) {
      this.dealerIndex.map(index => {
        this.filterDealer.push(this.showCriteria[index])
      });
      this.showCriteria.push({
        id: 'maxDealer',
        label: 'Dealer Name',
        value: this.dealerSelected[0].name + " + " + (this.dealerCount - 1)
      })
    }
      if (Object.keys(this.regionIndex).length > 3 && this.isRegionAll != true) {
      this.regionIndex.map(index => {
        this.filterRegion.push(this.showCriteria[index])
      });
      this.showCriteria.push({
        id: 'maxRegion',
        label: 'Region',
        value: this.regionSelected[0].codeDescription + " + " + (this.regionCount - 1)
      })
    }

    if (Object.keys(this.assignToIndex).length > 3 && this.isAssignToAll != true) {
      this.assignToIndex.map(index => {
        this.filterAssignTo.push(this.showCriteria[index])
      });
      this.showCriteria.push({
        id: 'maxAssignTo',
        label: 'Assigned To',
        value: this.assignToSelected[0].fullName + " + " + (this.assignToCount - 1)
      })
    }
    if (Object.keys(this.caseSourceIndex).length > 3 && this.isCaseSourceAll != true) {
      this.caseSourceIndex.map(index => {
        this.filterCaseSource.push(this.showCriteria[index])
      });
      this.showCriteria.push({
        id: 'maxCaseSource',
        label: 'Case Source',
        value: this.caseSourceSelected[0].code + " + " + (this.caseSourceCount - 1)
      })
    }

    //Filtering values
    let filtered = this.showCriteria.filter(item => !this.filterStatus.includes(item));
    this.showCriteria = filtered;

    filtered = this.showCriteria.filter(item => !this.filterPriority.includes(item));
    this.showCriteria = filtered;

    filtered = this.showCriteria.filter(item => !this.filterCaseType.includes(item));
    this.showCriteria = filtered;

    filtered = this.showCriteria.filter(item => !this.filterDealer.includes(item));
    this.showCriteria = filtered;

    filtered = this.showCriteria.filter(item => !this.filterRegion.includes(item));
    this.showCriteria = filtered;

    filtered = this.showCriteria.filter(item => !this.filterAssignTo.includes(item));
    this.showCriteria = filtered;

    filtered = this.showCriteria.filter(item => !this.filterCaseSource.includes(item));
    this.showCriteria = filtered;


    this._caseService.caseAdvanceSearch(this.caseSearchObj, (result) => {
      this.showAdvance = false;
      this.caseList = result.beans;

      if (this.advanceOffset == 0) {
        sessionStorage.removeItem("totalCount");
        this.totalRecords = result.pageCount;
        sessionStorage.setItem("totalCount", result.pageCount);
      }

      if (this.caseList == '') {
        this.showNext = false;
        this.noData = true;
      } else if (this.caseList.length < 10) {
        this.showNext = false;
        this.noData = false;
      } else if (this.caseList.length == 10) {
        this.showNext = true;
        this.noData = false;
      } else if (this.caseList.length > 10) {
        this.noData = false;
      } else {
        this.showNext = false;
        this.showBack = false;
        this.noData = true;
      }

      if (sessionStorage.getItem('totalCount') != null) {
        this.totalRecords = Number(sessionStorage.getItem("totalCount"));
      }
      if (this.caseList.length == 10) {
        this.noData = true;
      }
    })
  }

  /**
   * @author Anand
   * @description get status list
   */
  getStatusList() {
    this._caseService.getStatusList(this.userId, (result) => {
      this.statusList = result;
    });
  }

  /**
   * @author Anand
   * @description get priority list
   */
  getPriorityList() {
    this._caseService.getPriorityList(this.userId, (result) => {
      this.priorityList = result;
    });
  }

  /**
   * @author Anand
   * @description case source list
   */
  getCaseSourceList() {
    this._caseService.getCaseSourceList(this.userId, (result) => {
      this.caseSourceList = result;
    });
  }

  /**
   * @author Anand
   * @description lead source list
   */
  getDealerList() {
    this._caseService.getDealerList(this.userId, (result) => {
      this.dealerList = result;
    });
  }

  /**
   * @author Anand
   * @description lead source list
   */
  getCaseTypeList() {
    this._caseService.getCaseTypeList(this.userId, (result) => {
      this.caseTypeList = result;
    });
  }

  /**
   * @author Anand
   * @description lead source list
   */

  getAssignToList() {
    this._caseService.getAssignToList(this.userId, (result) => {
      result.sort(function(a,b){
          if ( a.fullName < b.fullName ){
            return -1;
          }
          if ( a.fullName > b.fullName ){
            return 1;
          }
          return 0;
      });
      result.forEach(obj => {
        this.assignToList.push({
          id: obj.id,
          firstName: obj.firstName,
          lastName: obj.lastName,
          fullName: obj.firstName + ' ' + obj.lastName
        })
      })
    });
  }

  showadvanceSearch(value) {
    this.showAdvance = value;
    if (this.showAdvance) {
      this.showBack = false;
      this.showAdvanceLink = false
    } else {
      this.offset = 0;
      this.basicOffset = 0;
      this.advanceOffset = 0;
      this.searchKey = "";
      this.showsubmission = false;
      this.showsubmissionrange = false;
      this.caseSearchObj.caseOpenDate = null;
      this.showAdvanceLink = true;
      this.showCriteria = [];
      this.getCaseList();
    }
  }

  showdaterange(val) {

    if (val) {
      this.caseSearchObj.caseOpenDate = "";
      this.openDate = null;
      this.showsubmission = false;
      this.showsubmissionrange = true;
      this.RDSelected =""
    } else {
      this.caseSearchObj.fromDate = "";
      this.fromDate = null;
      this.toDate = null;
      this.caseSearchObj.toDate = "";
      this.showsubmission = true;
      this.showsubmissionrange = false;
      this.RDSelected =""
    }
  }

  /**
   * @author Nagendra
   * @description Get Previous Page
   */
  GoBack() {
    this.offset -= 10;
    if (this.offset == 0) {
      this.showBack = false;
      this.noData = false;
    }
    if (this.advanceSearchList == true) {
      this.offset = 0;
      this.basicOffset = 0;
      this.advanceOffset -= 10;
      if (this.advanceOffset == 0) {
        this.showBack = false;
        this.noData = false;
      } else if (this.advanceOffset > 0) {
        this.showNext = true;
      }
      this.advanceSearch();
    } else if (this.normalSearch == true) {
      this.offset = 0;
      this.advanceOffset = 0;
      this.basicOffset -= 10;
      if (this.basicOffset == 0) {
        this.showBack = false;
        this.noData = false;
      }
      if (this.basicOffset > 0) {
        this.showNext = true;
      }
      this.basicSearch();
    } else {
      this.getCaseList();
    }

  }

  /**
   * @author Nagendra
   * @description Get Next Page
   */
  nextPage() {
    this.showBack = false;
    this.offset += 10;
    if (this.offset > 0) {
      this.showBack = true;
    }
    if (this.advanceSearchList == true) {
      this.offset = 0;
      this.basicOffset = 0;
      this.advanceOffset += 10;
      if (this.advanceOffset > 0) {
        this.showBack = true;
      }
      this.advanceSearch();
    } else if (this.normalSearch == true) {
      this.offset = 0;
      this.advanceOffset = 0;
      this.basicOffset += 10;
      if (this.basicOffset > 0) {
        this.showBack = true;
      }
      this.basicSearch();
    } else {
      this.getCaseList();
    }
  }

  @HostListener('document:click', ['$event'])
  clickedOutside($event) {
    const thisObj = this;
    if (!thisObj.showAdvanceLink && $($event.target).closest('div.search-boxdiv').length == 0 && $($event.target).closest('div.adv-topdiv').length == 0 && ($($event.target).closest('a.adv-search').length == 0)) {
      if (!thisObj.datePickerClick) {
        this.showAdvance = false;
        this.showAdvanceLink = true
        //thisObj.searchFormObj.reset();
      } else {
        thisObj.datePickerClick = false;
      }
    }
  }

  /**
   * @author Pradeep
   * @description redirect to case detail page
   */
  viewCasesDetails(caseId) {
    sessionStorage.setItem("pageNo",String(this.p));
    if (this.normalSearch == true) {
      this.normalSearchValues.lastName = this.searchKey.trim();
      this.normalSearchValues.sortBy = this.sort;
      this.normalSearchValues.orderBy = this.column;
      this.normalSearchValues.direction = this.direction;
      sessionStorage.removeItem('advanceSearch');
      sessionStorage.removeItem('advanceSearchDirection');
      sessionStorage.removeItem('advancesearchfields');
      sessionStorage.removeItem('list');
      sessionStorage.removeItem('caseListValues');
      sessionStorage.removeItem("selectOrDeselect");
      sessionStorage.setItem("normalSearch", this.basicOffset.toString());
      sessionStorage.setItem("normalSearchValues", JSON.stringify(this.normalSearchValues));
    } else if (this.advanceSearchList == true) {

      sessionStorage.removeItem('normalSearch');
      sessionStorage.removeItem('normalSearchValues');
      sessionStorage.removeItem('list');
      sessionStorage.removeItem('caseListValues');

      if (this.caseSearchObj.caseOpenDate != null && this.caseSearchObj.caseOpenDate != "" && this.openDate != null) {
        this.caseSearchObj.caseOpenDate = this.openDate.toDateString();
      }
      if (this.caseSearchObj.fromDate != null && this.caseSearchObj.fromDate != "" && this.fromDate != null) {
        this.caseSearchObj.fromDate = this.fromDate.toDateString();
      }
      if (this.caseSearchObj.toDate != null && this.caseSearchObj.toDate != "" && this.toDate != null) {
        this.caseSearchObj.toDate = this.toDate.toDateString();
      }
      sessionStorage.setItem("advanceSearch", this.advanceOffset.toString());
      sessionStorage.setItem("advanceSearchDirection", this.direction.toString());
      /**
       * @author Nagendra
       * @description Assiging local values of dropdown to session storage value (advancesearchfields)
       */
      this.caseSearchObj.statusIds = this.statusSelected;
      this.caseSearchObj.dealerIds = this.dealerSelected;
        this.caseSearchObj.regionIds = this.regionSelected
      this.caseSearchObj.priorityIds = this.prioritySelected;
      this.caseSearchObj.caseSourceIds = this.caseSourceSelected;
      this.caseSearchObj.assignTos = this.assignToSelected;
      this.caseSearchObj.caseTypeIds = this.caseTypeSelected;

      //Used for select all/de-select all boolean values
      this.selectOrDeselect = {
        'isStatusAll': this.isStatusAll,
        'isPriorityAll': this.isPriorityAll,
        'isCaseTypeAll': this.isCaseTypeAll,
        'isDealerAll': this.isDealerAll,
        'isAssignToAll': this.isAssignToAll,
        'isCaseSourceAll': this.isCaseSourceAll,
          'isRegionAll': this.isRegionAll
      };
      sessionStorage.setItem("selectOrDeselect", JSON.stringify(this.selectOrDeselect));
      sessionStorage.setItem("advancesearchfields", JSON.stringify(this.caseSearchObj));
    } else {
      this.caseListValues.sortBy = this.sort;
      this.caseListValues.orderBy = this.column;
      this.caseListValues.direction = this.direction;
      sessionStorage.removeItem('normalSearch');
      sessionStorage.removeItem('normalSearchValues');
      sessionStorage.removeItem('advanceSearch');
      sessionStorage.removeItem('advanceSearchDirection');
      sessionStorage.removeItem('advancesearchfields');
      sessionStorage.removeItem("selectOrDeselect");
      sessionStorage.setItem("list", this.offset.toString());
      sessionStorage.setItem("caseListValues", JSON.stringify(this.caseListValues));
    }
    this._router.navigate(['cases/detail/' + caseId])
  }

  setOffset() {
      if(this.fromDate != null){
       this.caseSearchObj.fromDate = this.fromDate.toString()
      } if (this.toDate != null){
          this.caseSearchObj.toDate = this.toDate.toString()
      }
    if(this.openDate != null){
        this.caseSearchObj.caseOpenDate = this.openDate.toString()
    }
    this.column = "";
    this.sort = "ASC";
    this.basicOffset = 0;
    this.advanceOffset = 0;
  }

  sortBy(i) {
    this.column = this.headerCasesList[i].setting.property.slice(5);
    this.direction = !this.direction;
    if (this.direction) {
      this.sort = "ASC";
    } else {
      this.sort = "DESC";
    }
    if (this.list) {
      this.offset = 0;
      this.showBack = false;
      this.showNext = false;
      this.noData = false;
      this.getCaseList();
    } else if (this.normalSearch) {
      this.showBack = false;
      this.showNext = false;
      this.noData = false;
      this.basicOffset = 0;
      this.basicSearch();
    } else {
      this.showBack = false;
      this.showNext = false;
      this.noData = false;
      this.advanceOffset = 0;
      this.advanceSearch();
    }
  }

  /*
  * @author Ciocan Vlad
  * @uses For pagination
  * @date 22-10-2018
  * @modified date 22-10-2018
  */

  pageChanged(event) {
    //console.log(this.p);
    if (this.pageExist != event) {
      this.pageExist = event;
      sessionStorage.setItem('casePageNo', event);
      if (this.advanceSearchList == true) {
        this.offset = 0;
        this.basicOffset = 0;
        if (event >= 1) {
          this.advanceOffset = (this.pageSize * (event - 1))
          //  console.log("****************advanceOffset******************" + this.advanceOffset);
        } else {
          this.advanceOffset = 0
        }
        this.advanceSearch();
      } else if (this.normalSearch == true) {
        this.offset = 0;
        this.advanceOffset = 0;
        if (event >= 1) {
          this.basicOffset = (this.pageSize * (event - 1))
          //   console.log("****************basicOffset******************" + this.basicOffset);
        } else {
          this.basicOffset = 0
        }
        this.basicSearch();
      } else {
        if (event >= 1) {
          this.offset = (this.pageSize * (event - 1))
          //  console.log("****************normal******************" + this.offset);
        } else {
          this.offset = 0
        }
        this.getCaseList();
      }
    }
  }

  /*
* @author Ciocan Vlad
* @uses To change page size for list
* @date 22-10-2018
* @modified date 22-10-2018
*/

  changepageSize() {
    // console.log("***1111111****************************************" + this.p)

    this.limit = this.pageSize;

    if (sessionStorage.getItem("pageLimit") !== null) {
      sessionStorage.removeItem("pageLimit")
    }
    sessionStorage.setItem("pageLimit", this.limit.toString());
    this._caseService.updatePageLimit(this.userId,this.limit,result=>{
//        console.log("result"+result)
    })
    if (this.advanceSearchList == true) {
      this.advanceSearch();
    } else if (this.normalSearch == true) {
      this.basicSearch();
    } else {
      this.getCaseList();
    }
  }

  /**
   * @author Nagendra
   * @description SelectAll and DeSelectAll from dropdowns
   * @uses To make empty array if select all or unselect all
   * @date 24-10-2018
   * @modified date 24-10-2018
   */
  onStatusSelectAll(value) {
    this.isStatusAll = true
  }

  onStatusDeSelectAll(value) {
    this.isStatusAll = false
  }

  onPrioritySelectAll(value) {
    this.isPriorityAll = true
  }

  onPriorityDeSelectAll(value) {
    this.isPriorityAll = false
  }

  onDealerSelectAll(value) {
    this.isDealerAll = true
  }

  onDealerDeSelectAll(value) {
    this.isDealerAll = false
  }
  onRegionSelectAll(value){
    this.isRegionAll = true
  }
  onRegionDeSelectAll(value){
      this.isRegionAll = false
  }

  onCaseTypeSelectAll(value) {
    this.isCaseTypeAll = true
  }

  onCaseTypeDeSelectAll(value) {
    this.isCaseTypeAll = false
  }

  onAssignToSelectAll(value) {
    this.isAssignToAll = true
  }

  onAssignToDeSelectAll(value) {
    this.isAssignToAll = false
  }

  caseSourceToSelectAll(value) {
    this.isCaseSourceAll = true
  }

  caseSourceToDeSelectAll(value) {
    this.isCaseSourceAll = false
  }

  /**
   * @author Nagendra
   * @description On select/deselect item from dropdowns
   * @date 24-10-2018
   * @modified date 24-10-2018
   */
  onStatusSelect(value) {
    this.isStatusAll = false
  }

  onStatusDeSelect(value) {
    this.isStatusAll = false
  }

  onPrioritySelect(value) {
    this.isPriorityAll = false
  }

  onPriorityDeSelect(value) {
    this.isPriorityAll = false
  }

  onDealerSelect(value) {
    this.isDealerAll = false
  }

  onDealerDeSelect(value) {
    this.isDealerAll = false
  }

   onRegionSelect(value){
    this.isRegionAll = false
  }

   onRegionDeSelect(value){
    this.isRegionAll = false
  }
  onCaseTypeSelect(value) {
    this.isCaseTypeAll = false
  }

  onCaseTypeDeSelect(value) {
    this.isCaseTypeAll = false
  }

  onAssignToSelect(value) {
    this.isAssignToAll = false
  }

  onAssignToDeSelect(value) {
    this.isAssignToAll = false
  }

  caseSourceToSelect(value) {
    this.isCaseSourceAll = false
  }

  caseSourceToDeSelect(value) {
    this.isCaseSourceAll = false
  }

  /**
   * @author Nagendra
   * @description Used to clear criteria in advance search and make selected values to empty
   * @created Date 25-10-2018
   * @modified Date 26-10-2018
   */
  clearCriteria() {
    this.caseSearchObj = new CaseAdvanceSearch(this.userId, "", [], [], [], [], [], "", null, null, null, [], null, 0, 10, true, "", "","",[],false);
    this.statusSelected = [];
    this.prioritySelected = [];
    this.caseTypeSelected = [];
    this.dealerSelected = [];
    this.assignToSelected = [];
    this.caseSourceSelected = [];
    this.caseExportStatus = true;
    //$('[data-toggle="tooltip"]').tooltip("enable");
    this.p=1;
  }

  /**
   * @author Nagendra
   * @description After criteria defined each value will be given with delete option from adv search
   * @created Date 25-10-2018
   * @modified Date 29-10-2018
   */
  removeFromCriteria(i) {
    const criteriaIndex = i;
    const criteriaLabel = this.showCriteria[i]['label'];
    const criteriaValue = this.showCriteria[i]['id'];
this.p=1;
    this.showCriteria.forEach(obj => {
          if (obj.label == "Relative Open Date" && criteriaLabel == "Relative Open Date") {
        this.RDSelected = "";
        this.caseSearchObj.fromDate = ""
        this.caseSearchObj.toDate = ""
        this.advanceSearch();
      }

      if (obj.label == "LastName" && criteriaLabel == "LastName") {
        this.searchKey = "";
        this.advanceSearch();
      }
       if (obj.label == "First Name" && criteriaLabel == "First Name") {
        this.caseSearchObj.firstName = "";
        this.advanceSearch();
      }
      if (obj.label == "Case Number" && criteriaLabel == "Case Number") {
        this.caseSearchObj.caseNumber = "";
        this.advanceSearch();
      }
      if (obj.label == "VIN" && criteriaLabel == "VIN") {
        this.caseSearchObj.vin = "";
        this.advanceSearch();
      }
      if (obj.label == "Open Date" && criteriaLabel == "Open Date") {
        this.caseSearchObj.caseOpenDate = "";
        this.openDate = null;
        this.advanceSearch();
      }
      if (obj.label == "From Date" && criteriaLabel == "From Date") {
        this.caseSearchObj.fromDate = "";
        this.fromDate = null;
        this.advanceSearch();
      }
      if (obj.label == "To Date" && criteriaLabel == "To Date") {
        this.caseSearchObj.toDate = "";
        this.toDate = null;
        this.advanceSearch();
      }


      //Dropdowns
      if (obj.label == "Status" && criteriaLabel == "Status") {
        this.statusSelected.forEach((obj, index) => {
          if (this.statusSelected[index]['id'] == criteriaValue) {
            this.statusSelected.splice(index, 1);
          }
        });
        //To remove Status All
        if (obj.id == 'statusAll' && this.showCriteria[criteriaIndex]['id'] == 'statusAll') {
          this.showCriteria.splice(criteriaIndex, 1);
          this.isStatusAll = false;
          this.statusSelected = [];
        }
        if (criteriaValue == 'maxStatus') {
          this.showCriteria.splice(criteriaIndex, 1);
          this.statusSelected = []
        }
        this.advanceSearch();
      }
      if (obj.label == "Priority" && criteriaLabel == "Priority") {
        this.prioritySelected.forEach((obj, index) => {
          if (this.prioritySelected[index]['id'] == criteriaValue) {
            this.prioritySelected.splice(index, 1);
          }
        });
        //To remove Priority All
        if (obj.id == 'priorityAll' && this.showCriteria[criteriaIndex]['id'] == 'priorityAll') {
          this.showCriteria.splice(criteriaIndex, 1);
          this.isPriorityAll = false;
          this.prioritySelected = [];
        }
        if (criteriaValue == 'maxPriority') {
          this.showCriteria.splice(criteriaIndex, 1);
          this.prioritySelected = []
        }
        this.advanceSearch();
      }
      if (obj.label == "Case Type" && criteriaLabel == "Case Type") {
        this.caseTypeSelected.forEach((obj, index) => {
          if (this.caseTypeSelected[index]['id'] == criteriaValue) {
            this.caseTypeSelected.splice(index, 1);
          }
        });
        //To remove Case Type All
        if (obj.id == 'caseTypeAll' && this.showCriteria[criteriaIndex]['id'] == 'caseTypeAll') {
          this.showCriteria.splice(criteriaIndex, 1);
          this.isCaseTypeAll = false;
          this.caseTypeSelected = [];
        }
        if (criteriaValue == 'maxCaseType') {
          this.showCriteria.splice(criteriaIndex, 1);
          this.caseTypeSelected = []
        }
        this.advanceSearch();
      }
      if (obj.label == "Dealer Name" && criteriaLabel == "Dealer Name") {
        this.dealerSelected.forEach((obj, index) => {
          if (this.dealerSelected[index]['id'] == criteriaValue) {
            this.dealerSelected.splice(index, 1);
          }
        });
        //To remove Dealer name All
        if (obj.id == 'dealerAll' && this.showCriteria[criteriaIndex]['id'] == 'dealerAll') {
          this.showCriteria.splice(criteriaIndex, 1);
          this.isDealerAll = false;
          this.dealerSelected = [];
        }
        if (criteriaValue == 'maxDealer') {
          this.showCriteria.splice(criteriaIndex, 1);
          this.dealerSelected = []
        }
        this.advanceSearch();
      }
       if (obj.label == "Region" && criteriaLabel == "Region") {
        this.regionSelected.forEach((obj, index) => {
          if (this.regionSelected[index]['id'] == criteriaValue) {
            this.regionSelected.splice(index, 1);
          }
        });
        //To remove Status All
        if (obj.id == 'regionAll' && this.showCriteria[criteriaIndex]['id'] == 'regionAll') {
          this.showCriteria.splice(criteriaIndex, 1);
          this.isRegionAll = false;
          this.regionSelected = [];
        }
        if (criteriaValue == 'maxRegion') {
          this.showCriteria.splice(criteriaIndex, 1);
          this.regionSelected = []
        }
        this.advanceSearch();
      }

      if (obj.label == "Case Source" && criteriaLabel == "Case Source") {
        this.caseSourceSelected.forEach((obj, index) => {
          if (this.caseSourceSelected[index]['id'] == criteriaValue) {
            this.caseSourceSelected.splice(index, 1);
          }
        });
        //To remove Case Source All
        if (obj.id == 'caseSourceNameAll' && this.showCriteria[criteriaIndex]['id'] == 'caseSourceNameAll') {
          this.showCriteria.splice(criteriaIndex, 1);
          this.isCaseSourceAll = false;
          this.caseSourceSelected = [];
        }
        if (criteriaValue == 'maxCaseSource') {
          this.showCriteria.splice(criteriaIndex, 1);
          this.caseSourceSelected = []
        }
        this.advanceSearch();
      }
      if (obj.label == "Assigned To" && criteriaLabel == "Assigned To") {
        this.assignToSelected.forEach((obj, index) => {
          if (this.assignToSelected[index]['id'] == criteriaValue) {
            this.assignToSelected.splice(index, 1);
          }
        });
        //To remove AssignTo All
        if (obj.id == 'assignToAll' && this.showCriteria[criteriaIndex]['id'] == 'assignToAll') {
          this.showCriteria.splice(criteriaIndex, 1);
          this.isAssignToAll = false;
          this.assignToSelected = [];
        }
        if (criteriaValue == 'maxAssignTo') {
          this.showCriteria.splice(criteriaIndex, 1);
          this.assignToSelected = []
        }
        this.advanceSearch();
      }
    });
    if (Object.keys(this.showCriteria).length == 0) {
      this.showadvanceSearch(false)
    }
  }

  onSelectOpen(event) {
    let d = new Date(Date.parse(event));
    this.caseSearchObj.caseOpenDate = `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`;
  }

  onSelectFrom(event) {
    let d = new Date(Date.parse(event));
    this.caseSearchObj.fromDate = `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`;
  }

  onSelectTo(event) {
    let d = new Date(Date.parse(event));
    this.caseSearchObj.toDate = `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`;
  }
/**
   * @author Vanitha
   * @description to get region list
   * @created Date 22-11-2019
   */
   getRegionList(){
       this._caseService.getRegionList((result)=>{
           this.regionList = result
       })
    }
  /**
   * @author Jayasimha
   * @description Export Leads using different criteria
   * @created Date 30-01-2019
   */
  exportCasesList() {
    let newHeader = [];
    let newcases;
    let column;
    this.finalExportData = [];
    this.caseSearchObj.isPagination = false;
    this.headerCasesList.forEach(prefprop => {
      newHeader.push(prefprop.setting.label);
    });
    if (this.normalSearch == true) {
      this._caseService.caseBasicSearch(this.userId, this.searchKey, 1, 1, this.column, this.sort,this.firatsNameRadioOption, (result) => {
        result.beans.forEach(eachObj => {
          newcases = {};
          this.headerCasesList.forEach(prefprop => {
            column = prefprop.setting.property.slice(5);
            if (eachObj[column] != "" || eachObj[column] != null) {
              if (column == "submissionDate" || column == "dateCreated" || column == "dateClosed") {
                eachObj[column] = eachObj[column] != null ? moment(eachObj[column]).format("MM/DD/YYYY HH:mm:ss"): "";
              }
              newcases[prefprop.setting.label] = eachObj[column];

            } else {
              newcases[prefprop.setting.label] = null;
            }
          });
          this.finalExportData.push(newcases);
        });
        var today: string = moment().format('D MMM YYYY HH:mm:ss');
        var options = {
          showLabels: true,
          headers: newHeader
        };
        new Angular2Csv(this.finalExportData, 'My_Report' + today, options);
      });
    } else if (this.advanceSearchList == true) {

      this._caseService.caseAdvanceSearch(this.caseSearchObj, (result) => {
        result.beans.forEach(eachObj => {
          newcases = {};
          this.headerCasesList.forEach(prefprop => {
            column = prefprop.setting.property.slice(5);
            if (eachObj[column] != "" || eachObj[column] != null) {
              if (column == "submissionDate" || column == "dateCreated" || column == "dateClosed") {
                eachObj[column] = eachObj[column] != null ? moment(eachObj[column]).format("MM/DD/YYYY HH:mm:ss"): "";
              }
              newcases[prefprop.setting.label] = eachObj[column];

            } else {
              newcases[prefprop.setting.label] = null;
            }
          });
          this.finalExportData.push(newcases);
        });
        var today: string = moment().format('D MMM YYYY HH:mm:ss');
        var options = {
          showLabels: true,
          headers: newHeader
        };
        new Angular2Csv(this.finalExportData, 'My_Report' + today, options);
      });
    } else {
      this._caseService.getCaseList(this.userId, this.offset, 100000, this.column, this.sort, (result) => {
        result.beans.forEach(eachObj => {
          newcases = {};
          this.headerCasesList.forEach(prefprop => {
            column = prefprop.setting.property.slice(5);
            if (eachObj[column] != "" || eachObj[column] != null) {
              if (column == "submissionDate" || column == "dateCreated") {
                eachObj[column] = moment(eachObj[column]).format("MM/DD/YYYY HH:mm:ss");
              }
              newcases[prefprop.setting.label] = eachObj[column];

            } else {
              newcases[prefprop.setting.label] = null;
            }
          });
          this.finalExportData.push(newcases);
        });
        var today: string = moment().format('D MMM YYYY HH:mm:ss');
        var options = {
          showLabels: true,
          headers: newHeader
        };
        new Angular2Csv(this.finalExportData, 'My_Report' + today, options);
      })
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/cases/components/case.component.ts